import { Component, OnInit, HostListener } from '@angular/core';
import { SharedService } from '../../services/shared/shared.service';
import { Router } from '@angular/router';
import { ForuscareService } from '../../services/foruscare/foruscare.service';

@Component({
  selector: 'app-topnavbar',
  templateUrl: './topnavbar.component.html',
  styleUrls: ['./topnavbar.component.css']
})
export class TopnavbarComponent implements OnInit {
  menuFolded: boolean;
  pageTitle: string = "Title";
  windowWidth = window.innerWidth;

  screenInfo: any;

  constructor(private sharedService: SharedService, public router: Router, public foruscareService: ForuscareService) {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }

  ngOnInit() {
    this.sharedService.screenInfoMessage.subscribe(info => this.screenInfo = info);
    if(this.sharedService.appMenuFolded){
      this.sharedService.appMenuFolded.subscribe(menufolded => {
        this.menuFolded = menufolded;
      });
    }
  }

  toggleSidebar() {
    this.menuFolded = !this.menuFolded;
    this.sharedService.setMenuFolded(this.menuFolded);
  }

  logout() {
    this.sharedService.logout();
    // this.sharedService.removeAccessToken();
    // this.router.navigate(['/login']);
    // this.foruscareService.showNotification("Logged  out successfully", "success");
  }
}
